import './_submenu-image-blocks.scss';
import component from './submenu-image-blocks';

export default component;
